import { LoginProcessorFactory } from '../../../../../core/processorfactory/loginprocessorfactory';
import { BaseContext } from '../../../../../utils/basecontext';
import { OTPCheckRequestImpl } from '../../../../../core/api/otp/otpcheck/otpcheckrequest';
import { OTPCheckResponse } from '../../../../../core/api/otp/otpcheck/otpcheckresponse';
import { SendOTPRequestImpl } from '../../../../../core/api/otp/sendotp/sendotprequest';
import { SendOTPResponse } from '../../../../../core/api/otp/sendotp/sendotpresponse';
import { OTPCheckDto } from '../../../../../core/dto/otp/otpcheck/otpcheckdto';
import { SendOTPDto, SendOTPDtoImpl } from '../../../../../core/dto/otp/sendotp/sendotpdto';
import { APIModel, APIModelHandler, APIModelImpl } from '../../../../toolkit/uicomponentapimodel';
/* import { GenerateOTPResponse } from 'src/com/sixdee/crbtportal/core/api/generateotp/generateotpresponse';
import { GenerateOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/generateotp/generateotprequest';
import { ConfirmOTPDto } from '../../../../../core/dto/otp/confirmotp/confirmotpdto';
import { ConfirmOTPResponse } from '../../../../../core/api/otp/confirmotp/confirmotpresponse';
import { ConfirmOTPRequestImpl } from '../../../../../core/api/otp/confirmotp/confirmotprequest';
import { SendOTPDtoImpl, SendOTPDto } from '../../../../../core/dto/otp/sendotp/sendotpdto'; */

export interface CreateAccountOTPMessageAPIModel extends APIModel
{
    otpCheck(createAccountOtpCheckDto: OTPCheckDto): void;
    resendOtp(msisdn: string): void;
}

export class CreateAccountOTPMessageAPIModelImpl extends APIModelImpl implements CreateAccountOTPMessageAPIModel
{
    private loginProcessorFactory: LoginProcessorFactory;
    
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
    }

    resendOtp(msisdn: string): void 
    {
        let sendotpdto = new SendOTPDtoImpl();
        sendotpdto.setMsisdn(msisdn);

        this.resendOtpFunc(sendotpdto);
    }

    otpCheck(createAccountOtpMsgDto: OTPCheckDto): void 
    {
        this.loginProcessorFactory.otpCheck()
        .success((otpCheckResponse : OTPCheckResponse)=>
        {
            this.getAPIModelHandler().onSuccess(otpCheckResponse.getAPIFeature(), 
            otpCheckResponse.getDescription(), otpCheckResponse);
        })
        .failure((otpCheckResponse : OTPCheckResponse)=>
        {
            this.getAPIModelHandler().onFailure(otpCheckResponse.getAPIFeature(), 
            otpCheckResponse.getDescription(), otpCheckResponse);
        }).execute(new OTPCheckRequestImpl(createAccountOtpMsgDto));    
    }

    private resendOtpFunc(createAccountSendOtpDto: SendOTPDto): void 
    {
        this.loginProcessorFactory.sendOTP()
                .success((generateOTPResponse : SendOTPResponse)=>
                {
                    this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                    generateOTPResponse.getDescription(), generateOTPResponse.getSendOTPDto());
                })
                .failure((generateOTPResponse : SendOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse);

                }).execute(new SendOTPRequestImpl(createAccountSendOtpDto));
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountotp/createaccountotpmessagecomponent/createaccountotpmessageapimodel.tsx